class RedemptionTable  {
	constructor() {
	//	this.redemptions = redemptions;
	}

	renderRedemptions(redemptions) {
       console.log(spapi.activeRedemptionOptions)
            
		redemptions.forEach((redemption) => {
            if (redemption.discount_type === "product") {
              

                $(".loyalty-redemption-table-container").append(
                    $("<div>").addClass("loyalty-redemption-container").append (
                      $("<a>", {
                        "data-variant-id" : redemption.applies_to_id,
                        "data-error-content" : "Looks like you are either not signed-in or don't have enough points for this product."
                      }).addClass("loyalty-product-redemption-link swell-buy-product-btn").append(
                    $("<div>").addClass("loyalty-redemption-cost").text(`${redemption.amount} Pieces`),
                     $("<div>").addClass("loyalty-redemption-name").text(redemption.name)
                    ))
                    );
            }
          if ((redemption.discount_type === "fixed_amount" && redemption.description.indexOf("off") !== -1 && redemption.description !== "$10 off for 125 pieces")  ) {
            console.log(redemption.description);
            $(".loyalty-readonly-redemption-options").append(
             $("<div>").addClass("loyalty-readonly-redemotion-option-container").append(
                	$("<div>").addClass("loyalty-readonly-redemotion-discount").text(redemption.prettyDiscount),
              $("<div>").addClass("loyalty-readonly-redemotion-cost").text(redemption.cost_text)
            )
            )
          }
          
          


          else if (redemption.discount_type === "cart_fixed_amount" && (redemption.description.indexOf("Free 300 or 550") !== -1) ||
                  (redemption.name == "Free 1000 PC Puzzle " && redemption.description == "Free 1000 PC Puzzle ") ||
                  (redemption.name == "2 Free 1000 PC Puzzles" && redemption.description == "2 Free 1000 PC Puzzles for 450 Points ")) {
            console.log(redemption.description);
            $(".loyalty-readonly-redemption-options").append(
             $("<div>").addClass("loyalty-readonly-redemotion-option-container").append(
                	$("<div>").addClass("loyalty-readonly-redemotion-discount").text(redemption.name),
              $("<div>").addClass("loyalty-readonly-redemotion-cost").text(redemption.cost_text)
            )
            )
          }
          
          
          
        })
    }         

    checkLoggedIn(customer) {
     
      if (customer.created_at === undefined) {
        setTimeout(function(){
        $(".loyalty-product-redemption-link").removeClass("swell-buy-product-btn");
      }, 5000);
    
    } 
  }
}